import React from "react";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import {
  SingleSelectorField,
  SingleSelectorFieldProps,
} from "../../../forms/SingleSelectorField";
import { StandardSelectOption } from "../../../selector/parts/SelectOption";

export function StateSelectorInputField<TFormValues extends FieldValues>({
  form,
  name,
  ...props
}: {
  form: UseFormReturn<TFormValues>;
  name: FieldPath<TFormValues>;
} & Omit<
  SingleSelectorFieldProps<TFormValues, string>,
  "form" | "name" | "label" | "options" | "placeholder"
>) {
  return (
    <SingleSelectorField
      form={form}
      name={name}
      label="State"
      options={StateSelectorOptions}
      {...props}
    />
  );
}

const StateSelectorOptions: StandardSelectOption[] = [
  { value: "ACT", data: { label: "ACT" } },
  { value: "NSW", data: { label: "NSW" } },
  { value: "NT", data: { label: "NT" } },
  { value: "QLD", data: { label: "QLD" } },
  { value: "SA", data: { label: "SA" } },
  { value: "TAS", data: { label: "TAS" } },
  { value: "VIC", data: { label: "VIC" } },
  { value: "WA", data: { label: "WA" } },
];
